import React, { useState } from "react"
import { graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

// We're using Gutenberg so we need the block styles
// these are copied into this project due to a conflict in the postCSS
// version used by the Gatsby and @wordpress packages that causes build
// failures.
// @todo update this once @wordpress upgrades their postcss version
import "../css/@wordpress/block-library/build-style/style.css"
import "../css/@wordpress/block-library/build-style/theme.css"

import Layout from "../components/layout"
import Seo from "../components/seo"
import ContentWithIndex from "../components/reusables/ContentWithIndex"

const ProjectItemTemplate = ({ data: { previous, next, portfolioItem } }) => {

  const [mobileTocShowing, setMobileTocShowing] = useState(false);

  const {
    content: portfolioContent, title: portfolioTitle
  } = portfolioItem;
  
  const seoData = {
    title: portfolioItem.PAseo?.seoTitle || 'Pavel Aparcana Projects',
    desc: portfolioItem.PAseo?.metaDescription || 'Read more about my projects.',
  }
  const bannerImage = {
    data: portfolioItem.portfolioMeta?.portfolioBanner?.localFile?.childImageSharp?.gatsbyImageData,
    alt: portfolioItem.portfolioMeta?.portfolioBanner?.altText || ``,
  }
  
  const dynamicLinks = portfolioItem.portfolioMeta?.dynamicLinks;

  const challengesAndSolutionsData = portfolioItem.portfolioMeta?.challengesAndSolutions


  const challengesList = [];
  
  const solutionsList = [];
  
  const scrollToChallenge = e => {
    e.preventDefault();
    const parent = e.currentTarget;

    if('solutionNum' in parent.dataset){

      if(mobileTocShowing) handleChallengeClick();
      
      const solutionId = parent.dataset['solutionNum'];

      const solutionEle = document.getElementById(solutionId);
      const solutionEleParent = solutionEle.parentElement;

      const challengesEle = document.getElementById('challenges');
      const topOfChallenges = challengesEle.getBoundingClientRect().top;

      if(topOfChallenges > 101 || topOfChallenges < 90){
        challengesEle.scrollIntoView({behavior: "smooth",});
        setTimeout(() => {
          solutionEleParent.scrollTop = solutionEle.offsetTop;
        }, 800);

      } else {
        solutionEleParent.scrollTop = solutionEle.offsetTop;
      }
    }
  }
  
  const populateChallenges = () => {
    challengesAndSolutionsData.forEach((challenge, idx) => {
      const challengeData = {
        title: challenge?.challengeTitle,
        solution: challenge?.challengeSolution
      }
      
      const solutionId = `sol-${idx + 1}`;

      if(challengeData.title){
        const challengeItem = (
          <li key={idx} data-solution-num={solutionId} 
          onClick={scrollToChallenge}>{challengeData.title}</li>
        );

        challengesList.push(challengeItem);
      }
      
      if(challengeData.solution){
        const solutionItem = (
          <section id={solutionId} key={idx}>
            <h3>{challengeData.title}</h3>
            <div dangerouslySetInnerHTML={{__html: challengeData.solution}}></div>
          </section>
        );
        
        solutionsList.push(solutionItem);
      }
      

    })
  }

  if(challengesAndSolutionsData && challengesAndSolutionsData.length > 0) populateChallenges();
  
  const handleChallengeClick = () => {
    // make body overflow hidden to prevent scroll
    // make h3 event listener close pop up filters
    const windowW = window.innerWidth;

    if(windowW > 767) return;
    
    const parent = document.getElementById('challenges');
    
    if(!mobileTocShowing){
      parent.classList.add('show-filters');
      
      setTimeout(() => {
        setMobileTocShowing(true)
        document.body.style.overflow = 'hidden';
      }, 400);
    } else {
      parent.classList.remove('show-filters');

      setTimeout(() => {
        setMobileTocShowing(false)
        document.body.style.overflow = '';
      }, 400);
    }
  }
  
  /**
   * needs:
   * - Project name
   * - Project Description
   * - Project Objective
   * - How you Built + test the app
   * 
   *  think about creating a story behind each post. Your portfolio should show how you work and solve business, programming, and tech problems.
   * 
   * Software Engineers are responsible for overseeing the creation of more complex applications and programs for computers, mobile devices, and other electronic hardware.
   */

  return (
    <Layout>
      <Seo title={seoData.title} description={seoData.desc} />

      <article
        className="portfolio-item blog-post"
        itemScope
        itemType="http://schema.org/Article"
      >
        <div className="project-banner col">
          <div className="container row">
            <div className="l-col col">
              <h1 className="border-b">{portfolioTitle}</h1>
            </div>
            <div className="banner-bg">
              {/* image */}
              <GatsbyImage className="pa-skill_logo" image={bannerImage.data} alt={bannerImage.alt}/>
            </div>
          </div>
        </div>
        <div className="project-content">
          <div className="container">
            <div className="row project2">
              <div className="col-2-3">
                <div className="project-overview">
                  <h2>Overview</h2>
                  <div dangerouslySetInnerHTML={{__html: portfolioContent}}></div>
                </div>
              </div>
              <div className="col-1-3">
                <ul>
                  {dynamicLinks&&dynamicLinks.map(({linkLabel, projectLink}) => {
                    const { target, title, url } = projectLink;

                    return (<li key={url}>
                      <h5>{linkLabel}</h5>
                      <a href={url} className="boxed-btn" target={target} rel="noreferrer">{title}</a>
                    </li>)
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <ContentWithIndex
          toc={challengesList}
          content={(
            <div className="col-4-5">
              {solutionsList}
            </div>
          )}
          sectionTitle={'Challenges & Solutions'}
          tocTitle={'Challenges'}
          handleMobileTocShow={handleChallengeClick}
          sectionId={'challenges'}
        />
      </article>

      <nav className="blog-post-nav">
        {/* <ul
          style={{
            display: `flex`,
            flexWrap: `wrap`,
            justifyContent: `space-between`,
            listStyle: `none`,
            padding: 0,
          }}
        >
          <li>
            {previous && (
              <Link to={previous.uri} rel="prev">
                ← {parse(previous.title)}
              </Link>
            )}
          </li>

          <li>
            {next && (
              <Link to={next.uri} rel="next">
                {parse(next.title)} →
              </Link>
            )}
          </li>
        </ul> */}
      </nav>
    </Layout>
  )
}

export default ProjectItemTemplate

export const pageQuery = graphql`
  query PortfolioItemById(
    $id: String!
    $previousPostId: String
    $nextPostId: String
  ) {
    portfolioItem: wpPortfolioItem(id: { eq: $id }) {
      id
      content
      title
      date(formatString: "MMMM YYYY")
      portfolioMeta {
        portfolioBanner {
          localFile {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
            }
          }
          altText
        }
        portfolioLogo {
          localFile {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
            }
          }
        }
        dynamicLinks {
          linkLabel
          projectLink {
            target
            title
            url
          }
        }
        challengesAndSolutions {
          challengeTitle
          challengeSolution
        }
      }
      PAseo {
        metaDescription
        seoTitle
      }
    }
    previous: wpPost(id: { eq: $previousPostId }) {
      uri
      title
    }
    next: wpPost(id: { eq: $nextPostId }) {
      uri
      title
    }
  }
`
